import { render } from "./index.vue?vue&type=template&id=5de6f454&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/spark/services/frontend/spark-cabinet-redesigned/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__